import { useEffect, useState } from "react";
import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "@/lib/api";
import { fmtUSD } from "@/lib/format";

export default function EquityCurve({ days = 30, height = 220 }) {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api
      .get("/portfolio/history", { params: { days } })
      .then(({ data }) => {
        if (!alive) return;
        setPoints((data.curve || []).map((p) => ({ t: p.t, value: p.value })));
      })
      .catch(() => alive && setPoints([]))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [days]);

  if (loading) {
    return (
      <div style={{ height }} className="w-full flex items-center justify-center text-sm text-gray-400">
        Loading equity curve…
      </div>
    );
  }
  if (points.length < 2) {
    return (
      <div style={{ height }} className="w-full flex items-center justify-center text-sm text-gray-400">
        Not enough data yet.
      </div>
    );
  }

  const first = points[0].value;
  const last = points[points.length - 1].value;
  const stroke = last >= first ? "#16a34a" : "#dc2626";

  return (
    <div style={{ height }} data-testid="equity-curve">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={points} margin={{ top: 8, right: 8, left: 8, bottom: 8 }}>
          <XAxis dataKey="t" hide type="number" domain={["dataMin", "dataMax"]} />
          <YAxis hide domain={["dataMin", "dataMax"]} />
          <Tooltip
            cursor={{ stroke: "#e5e7eb" }}
            contentStyle={{
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              fontFamily: "Manrope",
              fontSize: 12,
              padding: "8px 12px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
            }}
            labelFormatter={(t) => new Date(t).toLocaleDateString()}
            formatter={(v) => [fmtUSD(v), "Portfolio"]}
          />
          <Line type="monotone" dataKey="value" stroke={stroke} strokeWidth={2} dot={false} isAnimationActive={true} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
